module.exports = __webpack_public_path__ + "img/1504766487.75d8871f.jpg";